export default {
  primary: "var(--primary-color)",
  secondary: "var(--button-primary-color))",
  searchColorButton: "var(--button-primary-color)",
  darkColor: "var(--text-dark)",
  primaryButtonColor: "var(--button-primary-color)"
};
